<template>
	<div class="base-height recording" align='center'>
	    <header>
             <b>underConstruction </b><i class="material-icons"> warning</i>
            <h1>NOBA LAB</h1>
            <p>
                {{$t("phrase.editTitle")}}
            </p>
        </header>
        <div class="title">{{ $t("web") }} {{ $t("audio") }} <span>{{ $t("editing") }}</span></div>
        <br/><br/>

        <!-------------------- file upload ----------------------->
        <div class='normal'>
            <label id='ilabel'> {{$t("phrase.editDirection1")}}
                <input type="file" id="inputfile" v-on:change="onChange($event)" accept="audio/*">
            </label>

            <div id='myinline'>
                {{$t("phrase.editDirection2")}}
            </div>
        </div>
            
        <div class='normal' id='ifname'></div> 

        <canvas id="mycanvas"></canvas>

        <div class='normal graycolor'>{{$t("phrase.editWheel")}}</div>
        <BR/><BR/>

        <table id='ctrlicon'> 
            <!-- <caption>캡션</caption> -->
            <tr>
              <button
                type="button"
                id="btn_zoom_posiy"
                v-on:click="onZoomPosiY"
              >
                <img
                  class="ybtn marginr3"
                  src="../../assets/images/yp_h30.png"
                />Zoom Y +
              </button>
            </tr>
            <tr>
              <button
                type="button"
                id="btn_zoom_negay"
                v-on:click="onZoomNegaY"
              >
                <img
                  class="ybtn marginr3"
                  src="../../assets/images/ym_h30.png"
                />Zoom Y -
              </button>
            </tr>
            <tr>
              <button
                type="button"
                id="btn_zoomouty_full"
                v-on:click="onZoomOutfullY"
              >
                <img
                  class="ybtn marginr1"
                  src="../../assets/images/y0_h30.png"
                />Zoom Reset
              </button>
            </tr>
          </table>
        </td>
      </tr>

      <tr>
        <td>
          <table>
            <tr>
              <td>
                <button
                  type="button"
                  id="btn_zoom_posix"
                  v-on:click="onZoomPosiX"
                >
                  <img class="xbtn" src="../../assets/images/xp_w45.png" />
                </button>
              </td>
              <td>
                <button
                  type="button"
                  id="btn_zoom_negax"
                  v-on:click="onZoomNegaX"
                >
                  <img class="xbtn" src="../../assets/images/xm_w45.png" />
                </button>
              </td>
              <td>
                <button
                  type="button"
                  id="btn_zoomoutx_full"
                  v-on:click="onZoomOutfullX"
                >
                  <img class="xbtn" src="../../assets/images/x0_w45.png" />
                </button>
              </td>
            </tr>
            <tr>
              <td>Zoom X +</td>
              <td>Zoom X -</td>
              <td>Zoom Reset</td>
            </tr>
          </table>
        </td>
        <td>
          <button type="button" v-on:click="onZoomToSelection">
            <img
              class="zoomsel marginr3"
              src="../../assets/images/zoom_sel.png"
            />Zoom to Selection
          </button>
        </td>
      </tr>
    </table>

    <BR /><BR /><BR />

    <table id="cut_icons">
      <tr>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_cut"
            v-on:click="wv_on_cut"
          >
            <img src="../../assets/images/blue_cut_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_copy"
            v-on:click="wv_on_copy"
          >
            <img src="../../assets/images/blue_copy_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_paste"
            v-on:click="wv_on_paste"
          >
            <img src="../../assets/images/blue_paste_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_delete"
            v-on:click="wv_on_silent"
          >
            <img src="../../assets/images/blue_mute_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_fadein"
            v-on:click="wv_on_fadein"
          >
            <img src="../../assets/images/green_fadein_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_fadeout"
            v-on:click="wv_on_fadeout"
          >
            <img src="../../assets/images/green_fadeout_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_amplify"
            v-on:click="onAmplifyClick"
          >
            <img src="../../assets/images/green_amplify_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_undo"
            v-on:click="wv_on_undo"
          >
            <img src="../../assets/images/red_undo_64.png" />
          </button>
        </td>
        <td>
          <button
            type="button"
            class="image_btn"
            id="btn_download"
            v-on:click="onDownload"
          >
            <img src="../../assets/images/download_96.png" />
          </button>
        </td>
      </tr>

      <tr>
        <td>cut</td>
        <td>copy</td>
        <td>paste</td>
        <td>silent</td>
        <td>fadein</td>
        <td>fadeout</td>
        <td>amplify</td>
        <td>undo</td>
        <td>download</td>
      </tr>
    </table>

    <section>
      <br /><br /><br /><br />
      <div class="ad-box">{{ $t("advertise") }}</div>
    </section>

    <div id="usage">
      <Usage />
    </div>

    <!-- <div class="example-modal-window"> -->

    <MyModal v-if="isModalViewed" @close-modal="isModalViewed = false">
      <!-- <div class="black_bg"></div> -->
      <div class="modal_wrap dialog_body">
        <div class="hline mycenter" id="dialog_header">Download Settings</div>
        <div class="hline">
          <div class="dialog_title">Output filename(without extension):</div>
          <input
            type="text"
            id="outfname"
            name="outfname"
            value="output_filename"
          />
        </div>

        <div class="dialog_title">Output Format:</div>
        <div class="hline mycenter">
          <input
            id="mp3"
            type="radio"
            name="codec"
            value="mp3"
            checked="checked"
          />
          <label for="mp3"> mp3</label>
          <input id="wav" type="radio" name="codec" value="wav" />
          <label for="wav"> wav</label>
        </div>

        <div class="dialog_title">Select mp3 bitrate:</div>
        <div class="hline mycenter">
          <input
            class="bitrate"
            id="kbps128"
            type="radio"
            name="kbps"
            value="kbps128"
            checked="checked"
          />
          <label for="kbps128"> 128kbps</label>

          <input
            class="bitrate"
            id="kbps192"
            type="radio"
            name="kbps"
            value="kbps192"
          />
          <label for="kbps192"> 192kbps</label>

          <input
            class="bitrate"
            id="kbps384"
            type="radio"
            name="kbps"
            value="kbps384"
          />
          <label for="kbps384"> 384kbps</label>
        </div>

        <BR />

        <div class="mycenter" id="dialog_btn">
          <button
            class="btn_ok"
            type="button"
            id="modal_ok"
            v-on:click="onModalOK"
          >
            OK
          </button>
          <button
            class="btn_ok"
            type="button"
            id="modal_cancel"
            v-on:click="onModalCancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </MyModal>
    <!-- <button @click="isModalViewed = true">Open Modal</button> -->

    <!-- </div> -->
  </div>
</template>

<script>
import aaa from "../../plugins/audio_edit.js";
import MyModal from "./MyModal.vue";
import Usage from "@/components/Usage_edit";

export default {
  name: "editor",
  components: { MyModal, Usage },
  data() {
    return {
      isModalViewed: false,
    };
  },
  methods: {
    onChange(event) {
      aaa.handleFiles(event.target.files);
    },
    onZoomPosiX() {
      aaa.onZoomPosiX();
    },
    onZoomNegaX() {
      aaa.onZoomNegaX();
    },
    onZoomOutfullX() {
      aaa.onZoomOutfullX();
    },
    onZoomPosiY() {
      aaa.onZoomPosiY();
    },
    onZoomNegaY() {
      aaa.onZoomNegaY();
    },
    onZoomOutfullY() {
      aaa.onZoomOutfullY();
    },
    onZoomToSelection() {
      aaa.onZoomToSelection();
    },
    onPlay() {
      aaa.onPlay();
    },
    onStop() {
      aaa.onStop();
    },
    wv_on_cut() {
      aaa.wv_on_cut();
    },
    wv_on_copy() {
      aaa.wv_on_copy();
    },
    wv_on_paste() {
      aaa.wv_on_paste();
    },
    wv_on_silent() {
      aaa.wv_on_silent();
    },
    wv_on_fadein() {
      aaa.wv_on_fadein();
    },
    wv_on_fadeout() {
      aaa.wv_on_fadeout();
    },
    onAmplifyClick() {
      aaa.onAmplifyClick();
    },
    wv_on_undo() {
      aaa.wv_on_undo();
    },
    onDownload() {
      this.isModalViewed = true;
    },
    onModalOK() {
      aaa.onModalOK();
      this.isModalViewed = false;
    },
    onModalCancel() {
      this.isModalViewed = false;
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 3);
  },
  mounted() {
    aaa.mounted();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
header {
  width: 100%;
  height: 350px;
  background: url("../../assets/images/main-bg.jpg") no-repeat center center;
  background-size: cover;
  color: #fff;
  padding-top: 100px;
  margin-top: 62px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  font-size: 1.6rem;
  letter-spacing: 1px;
  h1 {
    font-size: 4.5rem;
    letter-spacing: 0.5rem;
    margin: 2rem 0;
  }
  i {
    vertical-align: bottom;
  }
  text-align: center;
}

.title {
  font-size: 3rem;
  margin-top: 5rem;
  text-align: center;
  span {
    color: #ff5252;
  }
}

.ad-box {
  max-width: 800px;
  margin: 0 auto;
  height: 100px;
  border-radius: 4px;
  border: 1px solid #eee;
}

.normal {
  margin: 1rem;
  font-size: 2rem;
}

#usage {
  text-align: left;
}

#mycanvas {
  margin: 30px;
  border: 4px solid #888;
}

#inputfile {
  display: none;
}

.showbox {
  border: 1px solid #f00;
}

#ilabel {
  display: inline;
  text-decoration: underline;
  color: blue;
  vertical-align: middle;
}
#myinline {
  display: inline;
  vertical-align: middle;
}

#ifname {
  margin-top: 50px;
}

// table{
//     table-layout: fixed;
//     width:80%;
//     border:none;
//     border-collapse: collapse;
// }
#btn_play {
  margin-right: 5rem;
}
.marginr3 {
  margin-right: 3rem;
}
.marginr1 {
  margin-right: 1rem;
}
.marginb2 {
  margin-bottom: 3rem;
}
.graycolor {
  color: gray;
}
.ybtn {
  height: 30px;
  width: 45px;
}
.xbtn {
  width: 34px;
  height: 45px;
}
.zoomsel {
  width: 44px;
  height: 44px;
}
#btn_zoom_to_sel {
  margin-right: 5rem;
}

#ctrlicon {
  //border:1px solid gray;
  width: 40%;
  border-collapse: collapse;
  border-radius: 10px;
  // border: 1px solid $blue;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
}

#cut_icons {
  width: 80%;
  margin-top: 4rem;
}

.nopad {
  padding: 0px;
}
th,
td {
  /* border: 1px solid #444444; */
  padding: 0px;
}

.dialog_body {
  height: 100%;
  font-size: 12px;
  font-family: Helvetica, Arial, sans-serif;
  color: #eee;
  text-decoration: none;
  opacity: 1;
}

.dialog_title {
  text-align: left;
}

#dialog_header {
  font-size: 18px;
}

.hline {
  border-bottom: 1px solid #777;
  overflow: hidden;
  padding-top: 6px;
  margin-top: 6px;
  margin-bottom: 10px;
  padding-bottom: 12px;
}

.mycenter {
  text-align: center;
}

#outfname {
  margin-top: 5px;
  margin-left: 5px;
  width: 90%;
  color: white;
  /* padding-top:0px;
        padding-bottom:0px;
        border: 1px solid white; */
}
/* #dialog_btn{
        display: inline;
        margin: 50px;
        font-size: 18px; 
        width:30px;
        background-color: #ccc;
        
    } */

.btn_ok {
  margin: 20px;
  font-size: 16px;
  /* width:30px; */
  background-color: #ccc;
}
@media all and (max-width: 1200px) {
  header {
    height: 250px;
    padding-top: 60px;
  }
  .ad-box {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 540px) {
  header {
    height: 200px;
    padding-top: 30px;
    h1 {
      font-size: 4rem;
      margin: 2.4rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 4rem;
    padding: 0 20px;
  }
  .ad-box {
    margin: 6rem auto 1rem;
    height: 80px;
    border: 1px solid #eee;
  }
}
@media all and (max-width: 376px) {
  header {
    font-size: 1.5rem;
    h1 {
      font-size: 4rem;
      margin: 2rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 2.5rem;
  }
  .ad-box {
    width: calc(100% - 20px);
  }
}
</style>
